export function btoa(str: string) {
  return window.btoa(str);
}



// WEBPACK FOOTER //
// ./src/util/btoa.web.ts